var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-card",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "left-box",
          attrs: {
            "body-style":
              "height:calc(100vh - 150px);overflow-y:auto;padding:0px 20px;padding-bottom: 0px",
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                height: "30px",
                "margin-bottom": "10px",
                "margin-top": "10px",
                width: "100%",
                display: "flex",
                "align-items": "center",
                "flex-wrap": "wrap",
                position: "relative",
                "justify-content": "space-between",
              },
            },
            [
              _c(
                "div",
                [
                  _c("el-input", {
                    staticStyle: { width: "300px", "margin-right": "10px" },
                    attrs: { clearable: "", placeholder: "设备名称/编号" },
                    model: {
                      value: _vm.searchData.DeviceName,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchData, "DeviceName", $$v)
                      },
                      expression: "searchData.DeviceName",
                    },
                  }),
                  _c(
                    "el-radio-group",
                    {
                      staticStyle: { "margin-right": "10px" },
                      on: { change: _vm.Search },
                      model: {
                        value: _vm.searchData.State,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchData, "State", $$v)
                        },
                        expression: "searchData.State",
                      },
                    },
                    [
                      _c("el-radio-button", { attrs: { label: "" } }, [
                        _vm._v("全部"),
                      ]),
                      _c("el-radio-button", { attrs: { label: 1 } }, [
                        _vm._v("待审核"),
                      ]),
                      _c("el-radio-button", { attrs: { label: 2 } }, [
                        _vm._v("已审核"),
                      ]),
                      _c("el-radio-button", { attrs: { label: 4 } }, [
                        _vm._v("驳回"),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary" },
                      on: { click: _vm.Search },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
              _c("div", [
                _c("span", { staticClass: "Quantity" }, [
                  _vm._v("设备数量小计：" + _vm._s(_vm.TotalQuantity)),
                ]),
                _c("span", { staticClass: "Quantity" }, [
                  _vm._v("设备数量总计：" + _vm._s(_vm.SumQuantity)),
                ]),
              ]),
            ]
          ),
          _c(
            "div",
            { staticStyle: { width: "100%" } },
            [
              _c(
                "el-table",
                {
                  attrs: { height: "calc(100vh - 240px)", data: _vm.dataList },
                  on: { "row-click": _vm.handleClick },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      type: "index",
                      label: "序号",
                      width: "55",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "设备编号",
                      prop: "device_no",
                      align: "center",
                      sortable: "",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "设备名称",
                      prop: "device_name",
                      align: "center",
                      sortable: "",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "设备规格",
                      prop: "specification",
                      align: "center",
                      sortable: "",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "设备数量",
                      prop: "Num",
                      align: "right",
                      sortable: "",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "安装日期",
                      prop: "purchase_date",
                      align: "center",
                      sortable: "",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "填写人",
                      prop: "cVenName",
                      align: "center",
                      sortable: "",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "生产厂家名称",
                      prop: "manufacturer",
                      align: "center",
                      sortable: "",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "维修商名称",
                      prop: "maintenance",
                      align: "center",
                      sortable: "",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "提交日期",
                      prop: "SubmitTime",
                      width: "130",
                      align: "center",
                      "show-overflow-tooltip": "",
                      sortable: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm
                                    .moment(scope.row.SubmitTime)
                                    .format("YYYY-MM-DD")
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "Status",
                      label: "状态",
                      align: "center",
                      width: "130",
                      sortable: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.Status == 1
                              ? _c("el-tag", { attrs: { type: "warning" } }, [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.Reviewer?.length == 1
                                        ? "部分审核"
                                        : "待审核"
                                    ) + " "
                                  ),
                                ])
                              : _vm._e(),
                            scope.row.Status == 2 || scope.row.Status == 3
                              ? _c("el-tag", { attrs: { type: "success" } }, [
                                  _vm._v("已审核 "),
                                ])
                              : _vm._e(),
                            scope.row.Status == 4
                              ? _c("el-tag", { attrs: { type: "danger" } }, [
                                  _vm._v("驳回 "),
                                ])
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "审核人",
                      prop: "Reviewer",
                      width: "130",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return _vm._l(scope.row.Reviewer, function (item) {
                            return _c("el-tag", { key: item }, [
                              _vm._v(_vm._s(item)),
                            ])
                          })
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                height: "40px",
                display: "flex",
                "align-items": "center",
                "justify-content": "right",
              },
            },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.pagination.PageIndex,
                  "page-sizes": _vm.pagination.PageSizes,
                  "page-size": _vm.pagination.PageRows,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.pagination.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ]
      ),
      _c("ScheduleView", {
        ref: "ScheduleView",
        on: { refresh: _vm.getDataList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }